import { gql } from '@efficiently/client-core-graphql-models';

export const GET_TAGS = gql(`
	query GetTags($type: TagType, $projectId: String) {
		tags(type: $type, projectId: $projectId) {
			...TagFields
		}
	}
`);
